module.exports = __webpack_public_path__ + "src/assets/images/marketing-materials-bg.png?3e095a370dd55080c1143ba08e5c7e49";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marketing-materials-bg.png
// module id = 1023
// module chunks = 1